import React from "react";
import './fcresult.css';

const OpenfiberResult = (props) => {
    const details = props.data?.OF?.details?.records?.[0];

    if (!details) return null;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div className="statGrid">
                <div className="statCard">
                    <span className="statLabel">Cluster Rete</span>
                    <span className="statValue" style={{ color: '#ff0f64' }}>{details.cluster || 'N/D'}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">POP Centralina</span>
                    <span className="statValue" style={{ color: '#0284c7' }}>{details.POP || 'N/D'}</span>
                </div>
                {details.STATO_UI && (
                    <div className="statCard">
                        <span className="statLabel">Stato Unità (UI)</span>
                        <span className="statValue" style={{
                            color: String(details.STATO_UI).toUpperCase().includes('CONN') || String(details.STATO_UI).toUpperCase().includes('VEND') || String(details.STATO_UI).toUpperCase().includes('ATTIV') || String(details.STATO_UI).toUpperCase().includes('OK') ? '#059669' : '#64748b'
                        }}>
                            {details.STATO_UI}
                        </span>
                    </div>
                )}
                {details.COORDINATE_BUILDING && (
                    <div className="statCard">
                        <span className="statLabel">Mappa Geografica</span>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.google.com/maps/search/?api=1&query=${details.COORDINATE_BUILDING.replace("_", "")}`}
                            style={{
                                color: '#0284c7',
                                fontWeight: '700',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                marginTop: '4px'
                            }}
                        >
                            Google Maps ↗
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OpenfiberResult;